import {
  GET_OUTAGE,
  GET_OUTAGE_SUCCESS,
  GET_OUTAGE_FAILURE,
} from '../actions/outage';

const INITIAL_STATE = { loading: true, requested: false };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_OUTAGE:
      return {
        ...state,
        loading: true,
        error: false,
        requested: true,
      };
    case GET_OUTAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload,
      };
    case GET_OUTAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
